/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Terms and Conditions View Model
    // Terms and Conditions Processing Information
    /**************************************/
    function TermsConditionsDocumentViewModel(termsType) {

        // Self-Identification
        var self = this;

        /***  PROPERTIES ***/
        this.ID = ko.validatedObservable(0);
		this.Title = ko.observable();
		this.ObjectDescription = ko.observable();
        this.RelatedObjectID = ko.validatedObservable(0);
        this.RelatedEntityID = ko.validatedObservable(0);
        this.LocationID = ko.observable();
        this.Obsolete = ko.observable();
        /***  PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        /*** SECTION PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.Paragraphs = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /*** COMPUTED PROPERTIES ***/
        this.IsRequired = ko.computed(function () {
            var required = false;
            for (var i = 0; i < this.Paragraphs().length; i++) {
                if (this.Paragraphs()[i].Required()) {
                    required = true;
                }
            }

            return required;

        }, this);

        this.AreAllParagraphVersionsLatest = ko.computed(function () {
            var latest = true;
            for (var i = 0; i < this.Paragraphs().length; i++) {
                if (this.Paragraphs()[i].IsUpdatedVersionAvaliable()) {
                    latest = false;
                }
            }

            return latest;
        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** METHODS ***/
        /*** METHODS ***/

        /*** SECTION METHODS ***/
        this.Initialize = function () {
        };
        this.LoadModel = function (container) {

            if (container != null) {
                this.ID(container.ID);
				this.Title(container.Title);
				this.ObjectDescription(container.ObjectDescription);
                this.RelatedObjectID(container.RelatedObjectID);
                this.RelatedEntityID(container.RelatedEntityID);
                this.LocationID(container.LocationID);
                this.Paragraphs([]);
                this.Obsolete(container.Obsolete);

                for (var i = 0; i < container.Paragraphs.length; i++) {
                    var item = new sm.portal.vm.TermsConditionsParagraphViewModel(termsType);
                    item.LoadModel(container.Paragraphs[i]);
                    this.Paragraphs.push(item);
                }
            }

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[TermsConditionsComposedDocumentVM] Data Loaded'); }
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new sm.portal.vm.TermsConditionsDocumentViewModel();
        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/
        this.ID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelatedObjectID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RelatedEntityID.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });


        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {

            var isCompleted = true;
            isCompleted = this.IsVMValid();

            if (isCompleted) {
                for (var i = 0; i < this.Paragraphs().length; i++) {
                    var paragraph = this.Paragraphs()[i];
                    if (!paragraph.Completed()) {
                        return false;
                    }
                }
            }

            return isCompleted;

        }, this);
        /*** VALIDATION METHODS ***/


        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        TermsConditionsDocumentViewModel: TermsConditionsDocumentViewModel,
    });

})(jQuery);